import PageContentSection from './pageContentSection'

export default PageContentSection
